import { render, staticRenderFns } from "./TermsView.vue?vue&type=template&id=1b74bbd0"
import script from "./TermsView.vue?vue&type=script&lang=js"
export * from "./TermsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports